import { RoutePath, type RoutePaths } from "@/lib/routes"
import { type MeterPowerAnalysisRouteNames } from "./meter-power-analysis-route-names"

const meterPowerAnalysisRootPath = RoutePath.create("/optimisation-compteur")

export const meterPowerAnalysisRoutesPaths = {
    fromDashboard: RoutePath.create(
        "/optimisation-compteur?productCode=:productCode&meterPointId=:meterPointId"
    ),
    landing: meterPowerAnalysisRootPath,
    error: meterPowerAnalysisRootPath.create("/erreur"),
    overload: meterPowerAnalysisRootPath.create("/victime-de-son-succes"),
    adapted: meterPowerAnalysisRootPath.create("/adaptee"),
    results: meterPowerAnalysisRootPath.create("/resultats"),
} as const satisfies RoutePaths<MeterPowerAnalysisRouteNames>
